import { render, staticRenderFns } from "./ForumReactions.vue?vue&type=template&id=2a10f6e4&scoped=true"
import script from "./ForumReactions.vue?vue&type=script&lang=js"
export * from "./ForumReactions.vue?vue&type=script&lang=js"
import style0 from "./ForumReactions.vue?vue&type=style&index=0&id=2a10f6e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a10f6e4",
  null
  
)

export default component.exports